import React, { useEffect, useState, useMemo } from "react";
import { IconButton, Divider } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import { makeStyles } from "@material-ui/core/styles";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import shortid from "shortid";
import "./pdfviewer.css";
import ReactResizeDetector from "react-resize-detector";
import { PDFFindController } from "./KPSFindController";
import { connect } from "react-redux";

var PdfjsWorker = require("worker-loader?esModule=false!pdfjs-dist/build/pdf.worker.js"); // eslint-disable-line
var pdfjsLib = require("pdfjs-dist/build/pdf");
var viewer = require("pdfjs-dist/web/pdf_viewer");
const useStyles = makeStyles((theme) => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  pdfViewerToolbar: {
    textAlign: "center",
    //width: "500px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  button: {
    // margin: theme.spacing(1),
  },
  zoomButton: {
    marginLeft: "2px",
    marginRight: "2px",
  },
  noSelectSpan: {
    userSelect: "none",
  },
}));
// pdfjsLib.GlobalWorkerOptions.workerPort = new PdfjsWorker();

function PDFViewer(props) {
  const viewerId = useMemo(() => shortid.generate(), [props.data]);
  const classes = useStyles();
  const [pdfFindController, setPdfFindController] = useState(null);
  const [pdfLinkService, setPdfLinkService] = useState(null);
  const [searchMatches, setSearchMatches] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentScale, setCurrentScale] = useState(1);
  const [pdfViewer, setPdfViewer] = useState(null);

  useEffect(
    () => {
      props.data &&
        props.data instanceof ArrayBuffer &&
        generatePdfViewer(props.data);
    },
    [props.data]
  );

  useEffect(
    () => {
      if (
        props.searchString &&
        props.searchString.replace(" ", "").length > 0
      ) {
        searchPdf(props.searchString);
      }
    },
    [props.searchString]
  );

  useEffect(
    () => {
      if (
        props.searchString &&
        props.searchString.replace(" ", "").length > 0
      ) {
        if (props.previousMatch) {
          previousMatch(props.searchString);
        } else if (props.nextMatch) {
          nextMatch(props.searchString);
        }
      }
    },
    [props.previousMatch, props.nextMatch]
  );

  // useEffect(
  //   () => {
  //     if (pdfViewer) {
  //       pdfViewer.currentScaleValue = 0.1;
  //       setCurrentScale(0.1);
  //     }
  //   },
  //   [pdfViewer]
  // );

  useEffect(() => {
    if(!pdfjsLib.GlobalWorkerOptions.workerPort) pdfjsLib.GlobalWorkerOptions.workerPort = new PdfjsWorker();
  }, []);

  const generatePdfViewer = (data) => {
    let result = null;
    setCurrentPageNumber(1);
    let container = document.querySelector("div#docCtr-" + viewerId);
    let eventBus = new viewer.EventBus();
    let pdfLinkService = new viewer.PDFLinkService({
      eventBus: eventBus,
      externalLinkTarget: 2,
    });
    pdfjsLib.externalLinkTarget = pdfjsLib.LinkTarget.BLANK;
    let pdfFindController = new PDFFindController({
      linkService: pdfLinkService,
      eventBus: eventBus,
    });
    result = new viewer.PDFViewer({
      container: container,
      eventBus: eventBus,
      linkService: pdfLinkService,
      findController: pdfFindController,
    });
    pdfLinkService.setViewer(result);

    let loadingTask = pdfjsLib.getDocument({
      data: props.data,
      disableAutoFetch: false,
    });

    loadingTask.onProgress = (progress) => {
      if (progress.loaded === progress.total) {
        // props.onLoaded && props.onLoaded();
      }
    };

    loadingTask.promise.then((pdf) => {
      const container = document.getElementById("ctr-" + viewerId);
      result.setDocument(pdf);

      setNumPages(pdf.numPages);
      pdfLinkService.setDocument(pdf, null);
      pdfFindController.setDocument(pdf, null);
      setPdfFindController(pdfFindController);
      setPdfLinkService(pdfLinkService);
      eventBus._on("pagechanging", (e) => {
        setCurrentPageNumber(e.pageNumber);
      });
      eventBus._on("pagerendered", (e, args) => {
        alignLayers();
        props.onLoaded && props.onLoaded();
      });
      eventBus._on("updatefindmatchescount", (e) => {
        setSearchMatches(e.matchesCount.total);
        props.onSearchMatchesUpdate &&
          props.onSearchMatchesUpdate(e.matchesCount);
      });
    });
    setPdfViewer(result);
  };

  const alignLayers = () => {
    const container = document.querySelector("#ctr-" + viewerId);
    if (container) {
      const pages = container.querySelectorAll("div > div.page");
      pages.forEach((page) => {
        const canvas = page.querySelector("div.canvasWrapper > canvas");
        const textLayer = page.querySelector("div .textLayer");
        if (textLayer) {
          textLayer.style.top = canvas.offsetTop + "px";
          textLayer.style.left = canvas.offsetLeft + "px";
          textLayer.style.height = canvas.offsetHeight + "px";
          textLayer.style.width = canvas.offsetWidth + "px";
        }
        const annotationLayer = page.querySelector("div .annotationLayer");
        if (annotationLayer) {
          annotationLayer.style.top = canvas.offsetTop + "px";
          annotationLayer.style.left = canvas.offsetLeft + "px";
          annotationLayer.style.height = canvas.offsetHeight + "px";
          annotationLayer.style.width = canvas.offsetWidth + "px";
        }
      });
    }
    if (props.isMobile && pdfViewer) {
      pdfViewer.currentScaleValue = 0.6;
      setCurrentScale(0.6);
    }
  };

  const nextMatch = (searchString) => {
    pdfViewer.findController.executeCommand("findagain", {
      query: searchString.trim(),
      phraseSearch: true,
      caseSensitive: false,
      highlightAll: false,
      findPrevious: false,
    });
  };

  const previousMatch = (searchString) => {
    pdfViewer.findController.executeCommand("findagain", {
      query: searchString.trim(),
      phraseSearch: true,
      caseSensitive: false,
      highlightAll: false,
      findPrevious: true,
    });
  };

  const searchPdf = (searchString) => {
    pdfViewer.findController.executeCommand("findagain", {
      query: searchString.trim(),
      phraseSearch: true,
      caseSensitive: false,
      highlightAll: false,
      findPrevious: false,
    });
  };

  const getFirstPdfPage = () => {
    pdfViewer.currentPageNumber = 1;
  };

  const getLastPdfPage = () => {
    pdfViewer.currentPageNumber = numPages;
  };

  const getNextPdfPage = () => {
    if (pdfViewer.currentPageNumber < numPages) {
      pdfViewer.currentPageNumber = pdfViewer.currentPageNumber + 1;
    }
  };

  const getPrevPdfPage = () => {
    if (pdfViewer.currentPageNumber > 1) {
      pdfViewer.currentPageNumber = pdfViewer.currentPageNumber - 1;
    }
  };

  const scaleDownPage = () => {
    const currentScaleValue = pdfViewer.currentScale;
    let newValue;
    if (currentScaleValue > 0.1) {
      newValue = currentScaleValue - 0.1;
    } else {
      newValue = currentScaleValue;
    }

    pdfViewer.currentScaleValue = newValue;
    setCurrentScale(newValue);
  };

  const scaleUpPage = () => {
    let newValue = pdfViewer.currentScale + 0.1;
    pdfViewer.currentScaleValue = newValue;
    setCurrentScale(newValue);
  };

  const onResize = () => {
    alignLayers();
  };

  return (
    <div className={classes.container} id="pdf-container">
      <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
      {numPages > 0 && (
        <div
          className={classes.pdfViewerToolbar}
          style={{
            display: !props.isMobile && "flex",
          }}
        >
          <div>
            <IconButton
              onClick={getFirstPdfPage}
              className={classes.button}
              aria-label="First page"
            >
              <FirstPageIcon />
            </IconButton>
            <IconButton
              onClick={getPrevPdfPage}
              className={classes.button}
              aria-label="Previous page"
            >
              <ChevronLeftIcon />
            </IconButton>
            <span className={classes.noSelectSpan}>
              {currentPageNumber} / {numPages}
            </span>
            <IconButton
              onClick={getNextPdfPage}
              className={classes.button}
              aria-label="Next page"
            >
              <ChevronRightIcon />
            </IconButton>
            <IconButton
              onClick={getLastPdfPage}
              className={classes.button}
              aria-label="Last page"
            >
              <LastPageIcon />
            </IconButton>
          </div>
          <span />
          <span className={classes.noSelectSpan}>
            <IconButton
              onClick={scaleDownPage}
              className={classes.zoomButton}
              aria-label="Zoom out"
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
            {Math.round(currentScale * 100)} %
            <IconButton
              onClick={scaleUpPage}
              className={classes.zoomButton}
              aria-label="Zoom in"
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </span>
        </div>
      )}
      <div style={{ flex: 1, overflow: "auto" }}>
        <Divider />
        <div id="loadingBar" />
        <div
          id={"docCtr-" + viewerId}
          style={{
            height: props.isSearch ? 600 : "99%",
            position: "relative",
            overflow: "auto",
          }}
        >
          <div id={"ctr-" + viewerId} tabindex="0" aria-label="PDF container">
            <div id="viewer" className="pdfViewer" />
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
});
export default connect(
  mapStateToProps,
  null
)(PDFViewer);
